import {ITenWebApiState} from "../reducers/10web-api.reducer";
import {createFeatureSelector, createSelector} from "@ngrx/store";
import {DbStoreState} from "../reducers";
import {MainDomainI} from "../../components/pages/10web-API/components/custom-domain/custom-domain.interface";

const getDbStoreState = createFeatureSelector<DbStoreState>('dbStore');

export const getTenWebApiState = createSelector(
  getDbStoreState,
  (dbStoreState: DbStoreState) => dbStoreState.tenWebApi
);

export const getClientResellerDataLoaded = createSelector(
  getTenWebApiState,
  (state: ITenWebApiState): boolean => state.loaded
);

export const getApiKeyGenerated = createSelector(
  getTenWebApiState,
  (state: ITenWebApiState): boolean => state.apiKeyGenerated
);

export const getApiKeyCreatedAt = createSelector(
  getTenWebApiState,
  (state: ITenWebApiState): string | null => state.apiKeyCreatedAt
);

export const getWebhookUrl = createSelector(
  getTenWebApiState,
  (state: ITenWebApiState): string | null => state.webhookUrl
);

export const getMainDomain = createSelector(
  getTenWebApiState,
  (state: ITenWebApiState): MainDomainI | null => state.domain
);

export const getLoading = createSelector(
  getTenWebApiState,
  (state: ITenWebApiState): boolean => state.loading
);

export const getError = createSelector(
  getTenWebApiState,
  (state: ITenWebApiState): any => state.error
);

export const getResellerProducts = createSelector(
  getTenWebApiState,
  (state: ITenWebApiState) => {
    if (state && state.products) {
      return {
        tenWebProducts: state.products['10web_products'] || [],
        wpProducts: state.products.wp_products || []
      };
    }
    return  null;
  }
);

export const getEnhancedPlugins = createSelector(
  getTenWebApiState,
  (state: ITenWebApiState) => state.enhancedPlugins
);

export const getEnhancedResellerProducts = createSelector(
  getResellerProducts,
  getEnhancedPlugins,
  (products, enhancedPlugins) => {
    if (!products) return null;

    if (!enhancedPlugins || enhancedPlugins.length === 0) {
      return products;
    }

    const enhancedPluginsMap = new Map(
      enhancedPlugins.map(plugin => [plugin.slug, plugin])
    );

    const enhancedTenWebProducts = products.tenWebProducts.map(product => {
      const enhanced = enhancedPluginsMap.get(product.slug);
      if (enhanced) {
        return {
          ...product,
          title: enhanced.title || product.title,
          author: enhanced.author || product.author,
          logo: enhanced.logo || product.logo || `https://ps.w.org/${product.slug}/assets/icon-256x256.png`
        };
      }
      return product;
    });

    const enhancedWpProducts = products.wpProducts.map(product => {
      const enhanced = enhancedPluginsMap.get(product.slug);
      if (enhanced) {
        return {
          ...product,
          title: enhanced.title || product.title,
          author: enhanced.author || product.author,
          logo: enhanced.logo || product.logo || `https://ps.w.org/${product.slug}/assets/icon-256x256.png`
        };
      }
      return product;
    });

    return {
      tenWebProducts: enhancedTenWebProducts,
      wpProducts: enhancedWpProducts
    };
  }
);
